import React, { Component } from 'react';
import ProjectPage from '../../components/ProjectPage';
import Table from '../../components/Table';
import Banner from '../../images/projects/ThrownInTheDungeonBanner.jpg'

class ThrownInTheDungeon extends Component {
  render() {
    return (
    <ProjectPage title="Thrown In The Dungeon" banner={Banner}>

      <div className='project-page-part'>

        <Table className="centered" data = {{
          Status : "Ongoing",
          Type : "Personal Project",
          Engine : "Unity",
          Language : "C#",
          Date : "2020 - Current"
        }}/>

      </div>

      <div className='project-page-part'>

        <h3>Context :</h3>
        <p className='basic-text'>
          Thrown In The Dungeon is my current personal project.<br/>

          The objective was to make a complete game using my knowledge and latest skills.<br/>
          The game was supposed to be a small project, I created a twitter account where I tried to tweet every day about the progression of the game to motivate me to work with a daily deadline.<br/>
          But at some point I encountered difficulties from bad code due to too short deadlines.<br/>
          <br/>
          I recently decided to continue the project after rewriting some old code.<br/>
          This project taught me a lot, taking time to write good code from the start is always better in the long run.<br/>
          
          Stay tuned to my twitter for more news. <a href="https://twitter.com/Just_APenguin" target="_blank" rel="noreferrer">@Just_APenguin</a>
        </p>

      </div>

      <div className='project-page-part'>

        <h3>Game :</h3>
        <p className='basic-text'>
          Thrown In The Dungeon is a top-down rogue lite game where you have to kill monsters to progress through a completely randomly generated dungeon.
        </p>

      </div>

      <div className='project-page-part'>

        <h3>Gameplay :</h3>

        <iframe className='project-video' title='Thrown In The Dungeon demo' allowFullScreen
        src="https://youtube.com/embed/XSw2eGGcs2c">
        </iframe>

      </div>

    </ProjectPage>
    );
  }
}

export default ThrownInTheDungeon;